module.exports = __webpack_public_path__ + "img/guojin.8f703e0b.png";